<app-admin-header [noHome]="true"></app-admin-header>

<app-no-data *ngIf="notifications.length == 0 && !skelition"></app-no-data>
<app-skelitions [value]="2" *ngIf="skelition"></app-skelitions>
<div *ngIf="notifications.length > 0" class="container-fluid v4-bg-img w-100">
  <div class="d-flex align-items-center justify-content-center w-100">
    <div style="width: 75%" class="row gap-3 mob-w-100">
      <div class="box col-md-3 col-12" style="height: fit-content">
        <div
          class="d-flex flex-column justify-content-start align-items-center"
        >
          <button
            style="width: 80%"
            *ngFor="let category of categoryFilters"
            (click)="changeCurrentFilter(category)"
            class=" {{
              currentCategory == category ? 'btn-fill' : 'btn-border'
            }}"
          >
            {{ getCategoryArabics(category) }}
          </button>
        </div>
      </div>
      <div class="box col overflow p-3">
        <div
          *ngFor="let notification of filteredNotifications"
          class="d-flex align-items-center {{
            isSeen(notification)
              ? 'notification-box-deactive'
              : 'notification-box-active'
          }} mb-3"
          role="button"
          (click)="markSeen(notification)"
        >
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex" style="width: 80%">
              <div class="notification-img-box">
                <img
                  *ngIf="checkIsImage(notification.image); else elseBlock"
                  class="notification-img"
                  src="{{ staticFileUrl + notification.image }}"
                  onerror="this.src='../../../assets/person-placeholder.jpg'"
                  alt="loading"
                />
                <ng-template #elseBlock>
                  <div class="notification-img d-center">
                    <i
                      class="{{ notification.image }}"
                      style="font-size: 2rem"
                    ></i>
                  </div>
                </ng-template>
              </div>
              <div class="column">
                <span
                  class="{{
                    isSeen(notification)
                      ? 'notification-label'
                      : 'notification-label-active'
                  }}"
                  >{{ notification.title }}</span
                >
                <span
                  class="{{
                    isSeen(notification)
                      ? 'notification-label-deactive'
                      : 'notification-label-active'
                  }}"
                  style="font-weight: 500; font-size: 12px"
                  >{{ notification.name }}</span
                >
                <span
                  class="{{
                    isSeen(notification)
                      ? 'notification-text'
                      : 'notification-text-active'
                  }}"
                  >{{ notification.message }}</span
                >
                <span
                  class="{{
                    isSeen(notification)
                      ? 'notification-date'
                      : 'notification-date-active'
                  }}"
                  >{{ getDateDifference(notification.createdAt) }}</span
                >
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="d-flex column line-h-0-5">
                <span
                  style="direction: ltr"
                  class="{{
                    isSeen(notification) ? 'hours-deactive' : 'hours-active'
                  }}"
                  >{{ getDateDifference(notification.createdAt) }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
